<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select']);

const handleChange = () => {
  if (!props.isActive) {
    emit('select', props.id);
  }
};
</script>

<template>
  <div
    class="radio-card relative cursor-pointer rounded-xl p-4 transition-all duration-200 py-4 ltr:pl-4 rtl:pr-4 ltr:pr-6 rtl:pl-6"
    :class="[isActive ? 'radio-card--active' : 'radio-card--inactive']"
    @click="handleChange"
  >
    <div class="absolute top-4 right-4">
      <input
        :id="`${id}`"
        :checked="isActive"
        :value="id"
        :name="id"
        type="radio"
        class="radio-input h-4 w-4"
        @change="handleChange"
      />
    </div>

    <!-- Content -->
    <div class="flex flex-col gap-3 items-start">
      <h3 class="text-sm font-medium text-n-slate-12">
        {{ label }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.radio-card {
  background: var(--wlab-bg-tertiary);
  border: 1px solid var(--wlab-border-default);
}

.radio-card--active {
  border-color: var(--wlab-text-secondary);
  background: var(--wlab-bg-hover);
}

.radio-card--inactive:hover {
  border-color: var(--wlab-text-muted);
}

.radio-input {
  accent-color: #fff;
  border-color: var(--wlab-text-muted);
}

.radio-input:checked {
  background-color: #fff;
  border-color: #fff;
}
</style>
